import React from 'react';
import { MessageCircle, Phone } from 'lucide-react';

const StickyContactBar = () => {
  const handleWhatsApp = () => {
    const message = 'Hi! I want to inquire about puppies at Petsmart Puppies.';
    window.open(`https://wa.me/917217648679?text=${encodeURIComponent(message)}`, '_blank');
  };

  const handleCall = () => {
    window.location.href = 'tel:+917217648679';
  };

  return (
    <>
      {/* Mobile-only sticky bar - clean and compact */}
      <div
        data-testid="sticky-contact-bar"
        className="sticky-contact-bar"
        style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          backgroundColor: '#1F2937',
          padding: '0.625rem 1rem',
          zIndex: 990,
          display: 'none' // Hidden by default, shown via CSS on mobile
        }}
      >
        <div className="flex items-center justify-between gap-3 max-w-lg mx-auto">
          {/* Left - Brand text */}
          <div className="flex items-center gap-2 min-w-0">
            <img 
              src="/petsmart-logo.png" 
              alt="" 
              className="w-7 h-7 rounded-full object-cover flex-shrink-0"
            />
            <span className="text-white text-sm font-medium truncate">
              Ask about Puppies
            </span>
          </div>

          {/* Right - Action buttons */}
          <div className="flex items-center gap-2 flex-shrink-0">
            <button
              onClick={handleWhatsApp}
              data-testid="sticky-whatsapp-button"
              className="flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-semibold transition-transform active:scale-95"
              style={{
                backgroundColor: '#25D366',
                color: 'white'
              }}
            >
              <MessageCircle size={16} />
              <span>Chat</span>
            </button>

            <button
              onClick={handleCall}
              data-testid="sticky-call-button"
              className="flex items-center justify-center w-8 h-8 rounded-full transition-transform active:scale-95"
              style={{
                backgroundColor: '#0EA5E9',
                color: 'white'
              }}
              aria-label="Call now"
            >
              <Phone size={16} />
            </button>
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          .sticky-contact-bar {
            display: block !important;
          }
          /* Add bottom padding to body to prevent content overlap */
          body {
            padding-bottom: 56px;
          }
        }
      `}</style>
    </>
  );
};

export default StickyContactBar;
